import { createSlice } from "@reduxjs/toolkit";
import { getDefaultSessionValue } from "../../class/user.schema";

export const currentSlice = createSlice({
  name: "current",
  initialState: {
    session: getDefaultSessionValue(),
  },
  reducers: {
    setInfo: (state, action) => {
      state.session = action.payload;
    },
  },
});

export const { setInfo } = currentSlice.actions;

export default currentSlice.reducer;
